import { useCallback, useEffect } from 'react';

import analytics from 'utils/client/analytics/analytics';
import { UbiArticlePage } from 'utils/ubi/pages/useUbiArticle';

interface UseTrackContactLinkArgs {
  ubi: UbiArticlePage;
  articleIdentifier: string;
}

const FEEDBACK_CONTACT_URI = 'feedback-widget/contact-spotify-support/';

/**
 * Hook which submits track events for when a user view and click on a `message us` button
 * @param {UbiArticlePage} ubi ubi instance for article page
 * @param {string} articleIdentifier article analytics identifier
 * @return {Function} trackMessageUsLink function to submit impression
 */
const useTrackMessageUsLink = ({ ubi, articleIdentifier }: UseTrackContactLinkArgs) => {
  useEffect(() => {
    ubi.logLinkImpression(FEEDBACK_CONTACT_URI);
  }, [ubi]);

  const trackMessageUsLink = useCallback(() => {
    analytics.trackEvent({
      category: 'article-feedback-contact-us',
      action: 'click',
      label: `/article/${articleIdentifier}/`,
      nonInteraction: true,
    });
    ubi.logLinkInteraction(FEEDBACK_CONTACT_URI);
  }, [ubi, articleIdentifier]);

  return {
    trackMessageUsLink,
  };
};

export default useTrackMessageUsLink;
